import React from "react";

import { Helmet } from "react-helmet";

const MetaHelmet = () => {
  const staticFileVersion = process.env.GATSBY_STATIC_FILE_VERSION || "1";

  return (
    <Helmet
      htmlAttributes={{
        lang: "ru",
        "xml:lang": "ru",
      }}
    >
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes, shrink-to-fit=no"
      />
      <link rel="apple-touch-startup-image" href={`/favicons/256.png?v=${staticFileVersion}`} />
      <meta name="x5-fullscreen" content="true" />
      <meta name="x5-page-mode" content="app" />
      <meta name="browsermode" content="application" />
      <meta name="full-screen" content="yes" />
      <meta property="al:web:url" content="https://lunaro.ru/" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="application-name" content="Lunaro" />
      <meta name="msapplication-starturl" content="https://lunaro.ru/catalog" />
      <meta name="msapplication-navbutton-color" content="#ffffff" />
      <meta
        name="msapplication-TileImage"
        content={`https://lunaro.ru/favicons/512.png?v=${staticFileVersion}`}
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="apple-touch-fullscreen" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="apple-mobile-web-app-title" content="Lunaro" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`https://lunaro.ru/favicons/180.png?v=${staticFileVersion}`}
      />
      <link
        rel="icon"
        href={`https://lunaro.ru/favicons/fav.svg?v=${staticFileVersion}`}
        type="image/svg+xml"
      />
      <meta
        name="yandex-tableau-widget"
        content={`logo=https://lunaro.ru/favicons/ya-tableau.png?v=${staticFileVersion}, color=#000000`}
      />
    </Helmet>
  );
};

export default MetaHelmet;
